import type { CSSProperties } from "react";

/** Soft tag fill — plan/35 (header + list pills share this). */
export function softTagStyle(
  color: string | null | undefined,
): CSSProperties {
  const c = color?.trim() || "#0a5f56";
  return {
    background: `color-mix(in oklab, ${c} 14%, transparent)`,
    color: "var(--color-foreground)",
    borderColor: `color-mix(in oklab, ${c} 26%, var(--color-border))`,
  };
}

/** Initials for assignee avatar chips — plan/29+35. */
export function personInitials(label: string): string {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] ?? ""}${parts[1]![0] ?? ""}`.toUpperCase();
}

/** How many tag pills before a quiet +N — plan/35. */
export const LIST_TAG_PILL_MAX = 2;

/** How many assignee avatars before +N. */
export const LIST_ASSIGNEE_AVATAR_MAX = 3;

export function overflowCount(total: number, maxVisible: number): number {
  if (total <= maxVisible) return 0;
  return total - maxVisible;
}
